module.exports = __webpack_public_path__ + "static/media/background-image-home-overlay.136298cd.png";